import { render, staticRenderFns } from "./SingleBookSkeltonLoader.vue?vue&type=template&id=58d4c3e5"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports